export default function Busy() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style={{ enableBackground: 'new 0 0 512 512' }}
      xmlSpace="preserve"
      className="w-8 h-8 fill-current text-white"
    >
      <g transform="translate(1 1)">
        <g>
          <g>
            <path
              d="M447,468.333h-42.667v-82.325c0-35.684-17.822-68.993-47.505-88.755L293.456,255l63.384-42.261
				c29.671-19.754,47.493-53.063,47.493-88.747V41.667H447c11.782,0,21.333-9.551,21.333-21.333C468.333,8.551,458.782-1,447-1h-64
				H127H63C51.218-1,41.667,8.551,41.667,20.333c0,11.782,9.551,21.333,21.333,21.333h42.667v82.325
				c0,35.684,17.822,68.993,47.505,88.755L216.544,255l-63.384,42.261c-29.671,19.754-47.493,53.063-47.493,88.747v82.325H63
				c-11.782,0-21.333,9.551-21.333,21.333S51.218,511,63,511h64h256h64c11.782,0,21.333-9.551,21.333-21.333
				S458.782,468.333,447,468.333z M148.333,123.992V41.667h213.333v82.325c0,21.416-10.689,41.392-28.484,53.24L255,229.36
				l-78.171-52.12C159.022,165.384,148.333,145.408,148.333,123.992z M148.333,468.333v-82.325c0-21.416,10.689-41.392,28.484-53.24
				L255,280.64l78.171,52.12c17.807,11.855,28.496,31.832,28.496,53.248v82.325H148.333z"
            />
            <path
              d="M272.751,189.915c6.535-9.804,3.884-23.049-5.919-29.583l-54.499-36.326l0-18.35c0-11.782-9.551-21.333-21.333-21.333
				c-11.782,0-21.333,9.551-21.333,21.333v18.347c0,14.266,7.114,27.552,18.964,35.48l54.538,36.351
				C252.972,202.369,266.217,199.719,272.751,189.915z"
            />
            <path
              d="M321.37,350.517l-54.538-36.351c-9.804-6.535-23.049-3.884-29.583,5.919c-6.535,9.804-3.884,23.049,5.919,29.583
				l54.499,36.326l0,18.35c0,11.782,9.551,21.333,21.333,21.333s21.333-9.551,21.333-21.333v-18.347
				C340.333,371.732,333.219,358.446,321.37,350.517z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
